import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"lock\"><path d=\"M19.5 10.875h-1.594v-5.25a3 3 0 0 0-3-3H9.094a3 3 0 0 0-3 3v5.25H4.5a.75.75 0 0 0-.75.75v9c0 .415.335.75.75.75h15a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75ZM7.781 5.625c0-.724.589-1.313 1.313-1.313h5.812c.724 0 1.313.589 1.313 1.313v5.25H7.78v-5.25Zm10.782 14.063H5.438v-7.125h13.125v7.124Zm-7.22-3.258v1.242c0 .103.085.187.188.187h.938a.188.188 0 0 0 .187-.187V16.43a1.125 1.125 0 1 0-1.312 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol